import firebase from "firebase/app";
import "firebase/database";
import { createListRecord } from "../../utils/listSchema";
import { rememberCreatedListTitle } from "../../services/createdListTitle";

const state = {
	items: [],
	lists: [],
	newList: null,
	newItem: null,
	donationValue: null,
	listName: null,
	listID: null,
};

const getters = {
	items: (state) => state.items,

	lists: (state) => state.lists,

	newList: (state) => state.newList,

	newItem: (state) => state.newItem,

	getDonationValue: (state) => state.donationValue,

	getlistName: (state) => state.listName,

	listID: (state) => state.listID,
};

// async methods
const actions = {
	// create New List
	createList({ commit }, payload) {
		const record = createListRecord(payload);
		return firebase
			.database()
			.ref("lists_2")
			.push(record)
			.then((snapshot) => {
				const key = snapshot.key;
				rememberCreatedListTitle(key, record.title);
				commit("unsetList");
				commit("unsetItems");
				commit("setList", key);
				return key;
			});
	},

	// create New Item
	createItem({ commit }, payload) {
		commit("unsetItem");
		return firebase
			.database()
			.ref("lists_2")
			.child(payload.list_id)
			.child("items")
			.push(payload)
			.then((snapshot) => {
				const key = snapshot.key;
				commit("setItem", key);
				return key;
			})
			.catch((err) => console.log(err));
	},

	changeListName({ state, commit, dispatch }, payload) {
		const newTitle = payload;
		const obj = { title: newTitle };

		// Optimistic update: update store immediately
		const previousTitle = state.listName;
		commit("setListName", newTitle);

		firebase
			.database()
			.ref("lists_2")
			.child(state.listID)
			.update(obj)
			.then(() => {
				// Ensure we are in sync with backend (and other clients)
				dispatch("fetchListTitle", state.listID);
			})
			.catch((err) => {
				console.log(err);
				// Roll back on error
				commit("setListName", previousTitle);
			});
	},

	fetchListTitle({ commit }, payload) {
		// Subscribe to title changes for reactive updates
		firebase
			.database()
			.ref("lists_2")
			.child(payload)
			.child("title")
			.on("value", (snapshot) => {
				commit("setListName", snapshot.val());
				commit("setListID", payload);
			});
	},

	//fetch items of list
	fetchListItems({ commit }, payload) {
		firebase
			.database()
			.ref("lists_2")
			.child(payload)
			.child("items")
			.on("value", (snapshot) => {
				commit("copyItems", snapshot);
			});
	},

	//fetch All Items
	fetchItems({ commit }) {
		commit("unsetItems");
		firebase
			.database()
			.ref("items")
			.on("value", (snapshot) => {
				commit("setItems", snapshot.val());
			});
	},

	// delete Item
	deleteListItem({ getters }, payload) {
		// move data item to archived collection
		let deletedItem = {};
		firebase
			.database()
			.ref("lists_2")
			.child(getters.listID)
			.child("items")
			.child(payload.id)
			.once("value", (snapshot) => {
				deletedItem = snapshot.val();
			});

		firebase
			.database()
			.ref("lists_2")
			.child(getters.listID)
			.child("archived")
			.push(deletedItem)
			.then((snapshot) => {})
			.catch((err) => console.log(err));

		firebase
			.database()
			.ref("lists_2")
			.child(getters.listID)
			.child("items")
			.child(payload.id)
			.remove();
	},

	// update Item
	updateListItem({ getters }, payload) {
		const obj = {
			who: payload.who,
			qty: payload.qty,
		};
		firebase
			.database()
			.ref("lists_2")
			.child(getters.listID)
			.child("items")
			.child(payload.id)
			.update(obj);
	},
	// update Item Name
	updateItemName({ getters }, payload) {
		const obj = {
			what: payload.what,
		};

		firebase
			.database()
			.ref("lists_2")
			.child(getters.listID)
			.child("items")
			.child(payload.id)
			.update(obj)
			.then(() => {
				// commit('updateItems', payload)
			});
	},

	// Update Item Quantity
	updateQuantity({ getters }, payload) {
		const obj = {
			qty: payload.qty,
		};

		return firebase
			.database()
			.ref("lists_2")
			.child(getters.listID)
			.child("items")
			.child(payload.id)
			.update(obj)
			.then(() => {
				// commit('updateItems', payload)
			});
	},

	async fetchDonation({ commit }, payload) {
		const snapshot = await firebase.database().ref("donation").once("value");
		commit("setDonationValue", snapshot.val().value);
	},

	async writeDonation({ dispatch }, payload) {
		await dispatch("fetchDonation");
		firebase
			.database()
			.ref("donation")
			.set({
				value: state.donationValue + 1,
			});
	},
};
const mutations = {
	setList: (state, payload) => (state.newList = payload),
	unsetList: (state) => (state.newList = null),

	setLists: (state, payload) => state.lists.push(payload),
	unsetLists: (state) => (state.lists = []),

	setItem: (state, payload) => (state.newItem = payload),
	unsetItem: (state) => (state.newItem = null),

	setListName: (state, payload) => (state.listName = payload),

	setListID: (state, payload) => (state.listID = payload),

	setDonationValue: (state, payload) => (state.donationValue = payload),
	incrementDonationValue: (state) =>
		(state.donationValue = state.donationValue + 1),

	setItems: (state, payload) => {
		let itemsArray = [];
		for (var item in payload) {
			payload[item].id = item;
			itemsArray.push(payload[item]);
		}

		state.items = itemsArray;
	},

	unsetItems: (state) => (state.items = []),

	copyItems: (state, payload) => {
		let tempArr = [];
		payload.forEach((i) => {
			let temp = {
				key: i.key,
				what: i.child("what").val(),
				qty: i.child("qty").val(),
				who: i.child("who").val(),
			};
			tempArr.push(temp);
		});
		// Sort functionality
		let unassignedItems = [];
		let assignedItems = [];
		tempArr.filter((item) => {
			if (item.who == null) {
				unassignedItems.push(item);
				unassignedItems.sort((a, b) =>
					a.what.toLowerCase() < b.what.toLowerCase() ? -1 : 1
				);
			}
		});
		tempArr.filter((item) => {
			if (item.who != null) {
				assignedItems.push(item);
				assignedItems.sort((a, b) =>
					a.what.toLowerCase() < b.what.toLowerCase() ? -1 : 1
				);
			}
		});

		tempArr = unassignedItems.concat(assignedItems);

		state.items = tempArr;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
